import * as React from 'react';

const b2bAddSmall = (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="20" height="20" rx="4" fill="white"/>
    <circle cx="15.234" cy="5.58411" r="3.76599" fill="url(#paint0_radial_23086_12574)"/>
    <circle cx="4.76575" cy="14.149" r="3.76599" transform="rotate(-180 4.76575 14.149)" fill="url(#paint1_radial_23086_12574)"/>
    <circle cx="2.94114" cy="5.66233" r="1.94114" fill="url(#paint2_linear_23086_12574)"/>
    <circle cx="17.0589" cy="14.0703" r="1.94114" transform="rotate(-180 17.0589 14.0703)" fill="url(#paint3_linear_23086_12574)"/>
    <g style={{ mixBlendMode: 'multiply' }}>
    <rect x="2.90332" y="3.72119" width="7.6131" height="3.80655" rx="1.90328" fill="url(#paint4_linear_23086_12574)"/>
    </g>
    <g style={{ mixBlendMode: 'multiply' }}>
    <rect x="17.0967" y="16.0115" width="7.6131" height="3.80655" rx="1.90328" transform="rotate(-180 17.0967 16.0115)" fill="url(#paint5_linear_23086_12574)"/>
    </g>
    <defs>
    <radialGradient id="paint0_radial_23086_12574" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(14.2925 3.70111) rotate(44.5888) scale(3.2747 5.90677)">
    <stop stop-color="#B9D5FF"/>
    <stop offset="1" stop-color="#2744FF"/>
    </radialGradient>
    <radialGradient id="paint1_radial_23086_12574" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(6.4071 16.2979) rotate(-135) scale(3.53553 6.37725)">
    <stop stop-color="#B9D5FF"/>
    <stop offset="1" stop-color="#2744FF"/>
    </radialGradient>
    <linearGradient id="paint2_linear_23086_12574" x1="4.27119" y1="6.97546" x2="-0.53373" y2="5.1961" gradientUnits="userSpaceOnUse">
    <stop stop-color="#2744FF"/>
    <stop offset="1" stop-color="#B9D5FF"/>
    </linearGradient>
    <linearGradient id="paint3_linear_23086_12574" x1="18.3889" y1="15.3835" x2="13.584" y2="13.6041" gradientUnits="userSpaceOnUse">
    <stop stop-color="#2744FF"/>
    <stop offset="1" stop-color="#B9D5FF"/>
    </linearGradient>
    <linearGradient id="paint4_linear_23086_12574" x1="8.50119" y1="6.05456" x2="5.0533" y2="5.13227" gradientUnits="userSpaceOnUse">
    <stop stop-color="#69B0FF"/>
    <stop offset="1" stop-color="white"/>
    </linearGradient>
    <linearGradient id="paint5_linear_23086_12574" x1="22.6945" y1="18.3448" x2="19.2467" y2="17.4226" gradientUnits="userSpaceOnUse">
    <stop stop-color="#69B0FF"/>
    <stop offset="1" stop-color="white"/>
    </linearGradient>
    </defs>
    </svg>

);

export default b2bAddSmall;